import { Meta, StoryObj } from "@storybook/nextjs-vite";
import { ResourceCard } from "./ResourceCard";

const meta: Meta<typeof ResourceCard> = {
  title: "Resource card",
  component: ResourceCard,
};

export default meta;

export const Default: StoryObj<typeof ResourceCard> = {
  args: {
    resourceType: "Resource type",
    type: "Resource",
    title: "Title",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent ligula tortor, varius in elementum malesuada, placerat nec sem. Nullam tempus enim orci, eget imperdiet nisl aliquet ut. Nunc quis egestas mauris, eu accumsan arcu. Ut fermentum, sapien eu sagittis faucibus, tellus nunc lobortis augue, nec tincidunt ante neque non urna.",
    link: {
      title: "Link",
      url: "#",
      dld: "dld",
      dlt: "dlt",
    },
  },
};
